import { professionalDisplayName } from './professional-name';
import { formatToTitleCase } from './format-to-title-case';

import { AllFavoritesTypes } from '@/types/favorites.types';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import defaultProfessionalSvg from '@/assets/avatars/default-professional.svg?url';
import defaultClinicSvg from '@/assets/avatars/default-clinic.svg?url';
import defaultLaboratorySvg from '@/assets/avatars/default-laboratory.svg?url';
import defaultBranchAvatarSvg from '@/assets/avatars/default-branch-avatar.svg?url';
import { Rating } from '@/types';

export const favoriteFormatName = (favorite: AllFavoritesTypes) => {
  const nameMap = {
    [EntityTypeEnum.PROFESSIONAL]: favorite?.professional ? professionalDisplayName(favorite?.professional) : '',
    [EntityTypeEnum.CLINIC]: formatToTitleCase(favorite.partner?.name ?? ''),
    [EntityTypeEnum.LABORATORY_COLLECT_POINT]: formatToTitleCase(favorite?.branchLaboratory?.name ?? ''),
    [EntityTypeEnum.BRANCH]: formatToTitleCase(`Medprev ${favorite.branch?.socialName}`),
  };
  return nameMap[favorite.favoritedEntityType] ?? '';
};

export const favoriteFormatAvatar = (favorite: AllFavoritesTypes) => {
  const avatarMap = {
    [EntityTypeEnum.PROFESSIONAL]: favorite?.professional?.avatar ?? defaultProfessionalSvg,
    [EntityTypeEnum.CLINIC]: favorite?.partner?.avatar ?? defaultClinicSvg,
    [EntityTypeEnum.LABORATORY_COLLECT_POINT]: favorite?.branchLaboratory?.avatar ?? defaultLaboratorySvg,
    [EntityTypeEnum.BRANCH]: defaultBranchAvatarSvg,
  };
  return avatarMap[favorite.favoritedEntityType] ?? '';
};

export const favoriteFormatLink = (favorite: AllFavoritesTypes) => {
  const linkMap = {
    [EntityTypeEnum.PROFESSIONAL]: `/profissionais/${favorite.slug}/`,
    [EntityTypeEnum.CLINIC]: `/parceiros/${favorite.slug}/`,
    [EntityTypeEnum.LABORATORY_COLLECT_POINT]: `/laboratorios/${favorite.slug}/`,
    [EntityTypeEnum.BRANCH]: `/unidade/${favorite.slug}/`,
  };
  return linkMap[favorite.favoritedEntityType] ?? '';
};

export const formatRating = (ratingEntity?: Rating): string => {
  if (!ratingEntity) {
    return 'Sem avaliações';
  }

  const rating = ratingEntity.fiveStars.average;

  if (rating === 0) {
    return 'Sem avaliações';
  }

  return rating.toFixed(1).replace('.', ',');
};
